import CoastLogo from '~/assets/icons/new/coast.svg?react';
import FleetioLogo from '~/assets/icons/new/fleetio.svg?react';
import FleetioAccountIcon from '~/assets/icons/new/fleetioAccountIcon.svg?react';

import { PARTNER_IDS, type PartnerBrand, type PartnerId } from './types';

// Kept separate from the partner config registry (`./index`) so PartnerLogo,
// which the wizard step components render, cannot import back into the same
// module that imports those step components — that cycle threw
// "Cannot access 'coastConfig' before initialization" at runtime.
export const PARTNER_BRANDS: Record<PartnerId, PartnerBrand> = {
  [PARTNER_IDS.COAST]: {
    icon: CoastLogo,
    wordmark: CoastLogo,
    accountCard: {
      icon: CoastLogo,
      tileAppearance: 'brand',
      iconAppearance: 'inverse',
    },
  },
  [PARTNER_IDS.FLEETIO]: {
    icon: FleetioLogo,
    wordmark: FleetioLogo,
    accountCard: {
      icon: FleetioAccountIcon,
      tileAppearance: 'outlined',
      iconAppearance: 'default',
    },
  },
};
